import style from "./style.module.css"
import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import videoPoster from "../../../assets/video-poster.png"
import axios from "axios";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux"
import { differenceInMinutes } from "date-fns"
import { useNavigate } from "react-router-dom"
// import { AllowPersmissions } from "./AllowPermissions";
import { Instructions } from "./Instructions";
import { updateTestDetails } from "../../../redux/actions/TestActions";

const SystemCheck = () => {
    const TestReducer = useSelector(store => store.TestReducer);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [error, setError] = useState("");
    const [micAverage, setMicAverage] = useState(0)
    const [maxSound, setMaxSound] = useState(0);
    const [isLoading, setIsLoading] = useState(false)
    // const [allowPermissions, setAllowPermissions] = useState(false);
    const [instructionPopUp, setInstructionPopUp] = useState(false);
    const [videoTrack, setVideoTracks] = useState("")
    const [broswerInfo, setBrowserInfo] = useState("");


    if (!TestReducer._id) {
        navigate("/exams", { replace: false })
    }
    const validation = () => {
        var isValid = true;
        if (error || !videoTrack) {
            toast.error("Please allow camera and mic permissions or camera or mic are unaccessible")
            isValid = false
        }
        else if (broswerInfo ? broswerInfo.name !== "Chrome" : false) {
            toast.error("Please use chrome browser only for exam.")
            isValid = false
        }
        else if (maxSound <= 25) {
            toast.error("Your mic sensitivity is too low. Please say 'Hello' until blue animation for sound starts animating")
            isValid = false
        }
        else if (videoTrack[0].label.toLowerCase().includes("virtual")) {
            toast.error("Virtual cameras are not allowed please turn of virtual camera!")
            isValid = false

        }


        return isValid;
    }

    const startTest = () => {
        navigate("/attemptExam", { replace: true })
    }

    const submit = () => {
        if (validation()) {
            setIsLoading(true)
            axios.get(`/getTimeDifference?date=${new Date()}`)
                .then(res => {
                    console.log(res);
                    if (!res.data.isValid) {
                        toast.error("Your system clock is not on proper time. Please reset your time according to indian region and try again.")
                        setIsLoading(false)
                        return;
                    }
                    else {
                        console.log(`start date - ${new Date(TestReducer.startDateTime).getDate()}-${new Date(TestReducer.startDateTime).getMonth() + 1}-${new Date(TestReducer.startDateTime).getFullYear()} ${new Date(TestReducer.startDateTime).getHours()}:${new Date(TestReducer.startDateTime).getMinutes()}`)
                        console.log(`end date - ${new Date(TestReducer.startDateTime).getDate()}-${new Date(TestReducer.endDateTime).getMonth() + 1}-${new Date(TestReducer.endDateTime).getFullYear()} ${new Date(TestReducer.endDateTime).getHours()}:${new Date(TestReducer.endDateTime).getMinutes()}`)
                        var startdifferenceinminutes = differenceInMinutes(new Date(), new Date(TestReducer.startDateTime), { roundingMethod: "round" })
                        var enddifferenceinminutes = differenceInMinutes(new Date(), new Date(TestReducer.endDateTime), { roundingMethod: "round" });
                        console.log(startdifferenceinminutes)
                        console.log(enddifferenceinminutes)

                        if (startdifferenceinminutes < 0) {
                            toast.error("This test is not started yet. Please try again at Scheduled time.")
                            setIsLoading(false)
                            return;
                        }
                        else if (enddifferenceinminutes > -1) {
                            console.log(enddifferenceinminutes)
                            toast.error("This test has ended. You can't appear for this test now.")
                            setIsLoading(false)
                            return;
                        }

                        
                        if(TestReducer.status === "Banned"){
                            toast.error("You are banned from this exam. You can't appear for this exam now!")
                                setIsLoading(false)
                                return;
                        }
                        else if( TestReducer.status === "Attempted Twice"){
                            toast.error("You attempted exam twice. You can't attempt exam again!")
                            setIsLoading(false)
                            return;
                        }
                        else if(TestReducer.status === "Submitted"){
                            toast.error("You submitted this exam already. Can't give this exam again")
                            setIsLoading(false)
                            return;
                        }
                        axios.get(`/getExamById/${TestReducer._id}`)
                            .then(res => {
                                setIsLoading(false)
                                console.log(res)
                                dispatch(updateTestDetails(res.data))
                                setInstructionPopUp(true)
                            })
                            .catch(err => {
                                setIsLoading(false)
                                console.log(err)
                                console.log(err.response)
                            })
                    }
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    setIsLoading(false)
                    toast.error("Something went wrong... :(")
                })
        }
    }




    useEffect(() => {
        // console.log(navigator.mediaDevices.enumerateDevices)
        navigator.browserSpecs = (function () {
            var ua = navigator.userAgent, tem,
                M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: (tem[1] || '') };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null) return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null)
                M.splice(1, 1, tem[1]);
            return { name: M[0], version: M[1] };
        })();

        setBrowserInfo(navigator.browserSpecs);

        if (TestReducer._id) {
            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: {
                    facingMode: {
                        exact: "user"
                    }
                }
            })
                .then(function (stream) {
                    console.log(stream)
                    stream.oninactive = () => {
                        console.log("on inactive")
                        toast.error("Camera or mic disconnected :(")
                        setVideoTracks("")
                    }
                    stream.onremovetrack = () => {
                        toast.error("Camera or mic disconnected :(")
                        setVideoTracks("")
                    }
                    var video = document.getElementById('videoTag');
                    setVideoTracks(stream.getVideoTracks())
                    console.log(stream.getVideoTracks())
                    console.log(stream.getAudioTracks())
                    video.srcObject = stream;

                    const audioContext = new AudioContext();
                    const analyser = audioContext.createAnalyser();
                    const microphone = audioContext.createMediaStreamSource(stream);
                    const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

                    analyser.smoothingTimeConstant = 0.8;
                    analyser.fftSize = 1024;

                    microphone.connect(analyser);
                    analyser.connect(scriptProcessor);
                    scriptProcessor.connect(audioContext.destination);
                    scriptProcessor.onaudioprocess = function () {
                        const array = new Uint8Array(analyser.frequencyBinCount);
                        analyser.getByteFrequencyData(array);
                        const arraySum = array.reduce((a, value) => a + value, 0);
                        const average = arraySum / array.length;
                        // console.log(Math.round(average));
                        setMicAverage(Math.round(average))
                        setMaxSound(maxSound => {
                            if (maxSound < Math.round(average)) {
                                return Math.round(average)
                            }
                            else {
                                return maxSound
                            }
                        })
                    };
                })
                .catch(function (err) {
                    /* handle the error */
                    console.error({ errorIs: err });
                    setError(err.message)
                    if(err.message){
                        toast.error(err.message)
                    }
                    else{
                        toast.error("Something went wrong while accessing the camera or microphone. Please try again later.")
                    }
                });
        }


    }, [TestReducer._id])


    // useEffect(() => {
    //     setTimeout(() => {
    //         if (!videoTrack) {
    //             setAllowPermissions(true)
    //         }
    //         else {
    //             setAllowPermissions(false)
    //         }
    //     }, 10000)
    // }, [videoTrack])

    return (
        <div className={style.rootDiv}>

            <Helmet>
                <title>System Check | Secure Examination</title>
            </Helmet>
            <h2 className={style.screenHeading}>System Check</h2>
            <div className={style.mainDiv}>
                {
                    instructionPopUp
                    &&
                    <Instructions
                        closePopup={() => startTest()}
                    />
                }
                <div className={style.videoWrapper}>
                    <video className={style.studentVideo} id="videoTag" poster={videoPoster} playsInline autoPlay muted></video>
                    <div className={style.micMainDiv}>
                        <div className={`${style.firstBar} ${micAverage > 25 && style.sideBarAnimation}`}></div>
                        <div className={`${style.secondBar} ${micAverage > 25 && style.mainBarAnimation}`}></div>
                        <div className={`${style.thirdBar} ${micAverage > 25 && style.sideBarAnimation}`}></div>
                    </div>
                </div>
                <p className={style.micNote}>Note:- Please say "Hello" loudly until blue animation of sound starts animating.</p>
                {
                    isLoading
                        ?
                        <button className={`${style.continueBtn}`}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </button>
                        :
                        <button onClick={() => submit()} className={`${style.continueBtn}`}>
                            Continue
                            <i className={"fas fa-arrow-circle-right " + style.continueIcon}></i>
                        </button>
                }
            </div>

        </div>
    )
}

export default SystemCheck;